import { useEffect, useState, useRef } from "react";
import { getApp } from "firebase/app";
import { getFunctions, httpsCallable } from "firebase/functions";

export default function ReviewPage({ bookingId }) {
  const [name, setName] = useState("");
  const [text, setText] = useState("");
  const [context, setContext] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [honeypot, setHoneypot] = useState("");
  const renderedAt = useRef(Date.now());

  const submit = async (e) => {
    e.preventDefault();
    if (submitting || !text.trim()) return;
    setSubmitting(true);
    setError(null);
    try {
      const fn = httpsCallable(getFunctions(getApp()), "submitTestimonial");
      await fn({
        text: text.trim(),
        authorName: name.trim() || null,
        context: context.trim() || null,
        orderId: null,
        bookingId: bookingId || null,
        website_url: honeypot,
        formRenderedAt: renderedAt.current,
      });
      setSubmitted(true);
    } catch (err) {
      setError(err.message || "Something went wrong. Try again?");
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div style={page}>
        <div style={card}>
          <div style={{ textAlign: "center", padding: "2rem 1rem" }}>
            <div style={{ fontSize: "2.5rem", marginBottom: "0.8rem" }}>🥞</div>
            <h2 style={{ ...heading, marginBottom: "0.6rem" }}>Thank you!</h2>
            <p style={body}>Your kind words mean a lot. They help other folks find us and keep the magic going.</p>
            <a href="https://thejoyofpancakes.com" style={cta}>Visit thejoyofpancakes.com →</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={page}>
      <div style={card}>
        <div style={{ textAlign: "center", padding: "0 0 1rem" }}>
          <img
            src="/jop_logo_wide.png"
            alt="The Joy of Pancakes"
            style={{ width: 200, maxWidth: "70%", marginBottom: "0.6rem" }}
          />
          <h2 style={heading}>How was your experience?</h2>
          <p style={{ ...body, color: "#8a7b6d" }}>
            A quick note from you helps other folks find us — and it honestly makes our week.
          </p>
        </div>

        <form onSubmit={submit}>
          <div style={{ position: "absolute", left: "-9999px", opacity: 0 }}>
            <input value={honeypot} onChange={(e) => setHoneypot(e.target.value)} tabIndex={-1} autoComplete="off" />
          </div>

          <label style={label}>Your name <span style={{ color: "#8a7b6d", fontWeight: 400 }}>(optional)</span></label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="How should we credit you?"
            style={input}
          />

          <label style={label}>What was the event? <span style={{ color: "#8a7b6d", fontWeight: 400 }}>(optional)</span></label>
          <input
            type="text"
            value={context}
            onChange={(e) => setContext(e.target.value)}
            placeholder="e.g. 'Our company picnic' or 'Sarah's birthday'"
            style={input}
          />

          <label style={label}>Your experience <span style={{ color: "#ef537e" }}>*</span></label>
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="How was it? What stood out? What would you tell a friend?"
            required
            rows={4}
            style={{ ...input, resize: "vertical", minHeight: "6rem", fontFamily: "inherit" }}
          />

          {error && <p style={{ color: "#ef537e", fontSize: "0.85rem", margin: "0.5rem 0 0" }}>{error}</p>}

          <button
            type="submit"
            disabled={submitting || !text.trim()}
            style={{
              ...cta,
              marginTop: "1.2rem",
              width: "100%",
              opacity: submitting || !text.trim() ? 0.5 : 1,
              cursor: submitting ? "wait" : "pointer",
            }}
          >
            {submitting ? "Sending…" : "Share your experience →"}
          </button>
        </form>
      </div>
      <p style={{ textAlign: "center", fontSize: "0.75rem", color: "#8a7b6d", marginTop: "1.2rem" }}>
        The Joy of Pancakes · <a href="https://thejoyofpancakes.com" style={{ color: "#1d52a0" }}>thejoyofpancakes.com</a>
      </p>
    </div>
  );
}

const page = {
  minHeight: "100vh",
  background: "#faf6ef",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "2rem 1rem",
  fontFamily: "'Fredoka', system-ui, sans-serif",
};

const card = {
  background: "#ffffff",
  borderRadius: 14,
  border: "1px solid #e0d9cf",
  padding: "2rem",
  maxWidth: 480,
  width: "100%",
};

const heading = {
  fontFamily: "'Fredoka', system-ui, sans-serif",
  fontSize: "1.35rem",
  color: "#1a0a12",
  fontWeight: 700,
  margin: 0,
};

const body = {
  fontFamily: "system-ui, sans-serif",
  fontSize: "0.95rem",
  color: "#3d2e24",
  lineHeight: 1.6,
  margin: "0.5rem 0 0",
};

const label = {
  display: "block",
  fontSize: "0.82rem",
  fontWeight: 600,
  color: "#3d2e24",
  marginTop: "1rem",
  marginBottom: "0.35rem",
};

const input = {
  width: "100%",
  boxSizing: "border-box",
  padding: "0.65rem 0.85rem",
  border: "1.5px solid #d6dfe8",
  borderRadius: 8,
  fontSize: "0.92rem",
  background: "#f9f9fa",
  outline: "none",
  color: "#1a0a12",
};

const cta = {
  display: "inline-block",
  background: "#fcb31f",
  color: "#1a0a12",
  fontWeight: 900,
  fontSize: "0.95rem",
  padding: "0.8rem 1.6rem",
  borderRadius: 999,
  textDecoration: "none",
  border: "none",
  letterSpacing: "0.03em",
  textAlign: "center",
  fontFamily: "inherit",
};
